import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TopFeatureTileContainer } from './topFeatureTile.styled';

interface TopFeatureTileProps {
  title: string;
  description: string;
  imageSrc: string;
  action: {
    onClick: (event: React.MouseEvent) => void;
    actionText: string;
    buttonType: 'primary' | 'secondary';
  };
  alignment: 'left' | 'right';
}

export default function TopFeatureTile({
  title,
  description: Description,
  imageSrc,
  altName,
  action,
  alignment = 'left',
}: TopFeatureTileProps) {
  return (
    <TopFeatureTileContainer $alignment={alignment}>
      <Image alt={altName} src={imageSrc} />
      <h3>{title}</h3>
      <Description />
      {Boolean(action) && (
        <Button buttonType={action.buttonType} onClick={action.onClick}>
          {action.actionText}
        </Button>
      )}
    </TopFeatureTileContainer>
  );
}
